import React, { useState, useEffect } from "react";
import "../../components/PetType/PetType.css";
import axios from "axios";

const PetType = ({tokenStorage,openProfile,setOpenProfile,petTypeId}) => {
  const [isEditMode, setIsEditMode] = useState(false);
  // const [petTypeDetailResponse, setPetTypeDetailResponse] = useState([]);

  const [firstItem, setFirstItem]=useState({
    id: petTypeId,
    petType:"",
  }) ;

  const baseAPI = process.env.REACT_APP_API_URL;


  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };
  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    // let petTypeId = localStorage.getItem("id");
    

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GEPetType?PetType=` +
            petTypeId,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          // setPetTypeDetailResponse(response.data.data);
          
          // if (response.data.data === 0) {
          //   return <p>No data available.</p>;
          // }        
          // Get the first item from the dataList
          setFirstItem(response.data.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching employee detail:", error);
        });
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setFirstItem({
      id: petTypeId,
    });
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}adminpost/AddPetType`,
        firstItem, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );


      // Optionally, reset the form
      setFirstItem({
        petType: "",
      });
      tokenStorage();
      setOpenProfile (!openProfile); 
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  return (
    <div className="container-fluid">
      <br />

      <div className="petTypeDetail">
        <div className="petTypeDetailHeader">
          <div className="ClearTab">
            <button className={isEditMode ? "saveButton" : "closeTabButton"} onClick={handleSubmit}>
              {isEditMode ? "Save" : "Close Tab"}
            </button>
            <button
              className={isEditMode ? "CancelButton" : "editButton"}
              onClick={toggleEditMode}
            >
              {/* Edit {isEditMode ? "" : ""} */}
              {isEditMode ? "Cancel" : "Edit"}
            </button>
          </div>
        </div>

        {/* ---------------------------------------------------------------------------------------------------------------- */}
        {isEditMode ? (
          // --------------Edit mode---------------//
          <form className="petType-form">
            <table style={{ width: "100%" }}>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Pet Type*</td>
              </tr>

              <tr key={firstItem.id}>
                <td>
                  <input placeholder="Enter Please" name="petType" value={firstItem.petType} onChange={handleChange}/>
                </td>
              </tr>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
            </table>
          </form>
        ) : (
          // --------------Display mode---------------//
          <div>
            <table style={{ width: "100%" }}>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Pet Type*</td>
              </tr>

              <tr key={firstItem.id}>
                <td>{firstItem.petType}</td>
              </tr>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
            </table>
          </div>
        )}
      </div>

      <br />
    </div>
  );
};

export default PetType;
